export default "__VITE_ASSET__CafMUFz3__"